import toast from 'react-hot-toast/headless'
import { useTranslation } from 'react-i18next'
import api from '../../api'
import { Organization, OrganizationCreateParams } from '../../types'
import { Heading, Modal } from '../../ui'
import FormWrapper from '../../ui/form/FormWrapper'
import TextInput from '../../ui/form/TextInput'
import './OrganizationCreateModal.css'

interface OrganizationCreateModalProps {
    open: boolean
    onClose: () => void
    onCreated: (organization: Organization) => void
}

export default function OrganizationCreateModal({ open, onClose, onCreated }: OrganizationCreateModalProps) {
    const { t } = useTranslation()

    return (
        <Modal open={open} onClose={onClose} size="regular" title={t('new_organization')}>
            <FormWrapper<OrganizationCreateParams>
                submitLabel={t('create_organization')}
                onSubmit={async params => {
                    const organization = await api.organizations.create({ ...params, domain: params.domain || undefined })
                    toast.success(t('organization_created', { name: organization.username }))
                    onCreated(organization)
                    onClose()
                }}
            >
                {form => {
                    const username = form.watch('username')
                    return <>
                        <TextInput.Field
                            form={form}
                            name="username"
                            label={t('subdomain')}
                            subtitle={t('subdomain_description', { subdomain: username || 'name' })}
                            pattern={/^[a-z0-9][a-z0-9-]{1,62}$/}
                            patternMessage={t('subdomain_invalid')}
                            required
                        />
                        <TextInput.Field form={form} name="domain" label={t('domain')} subtitle={t('organization_domain_description')} />
                        <Heading size="h4" title={t('organization_providers')} />
                        <p className="org-create-providers">{t('organization_providers_description')}</p>
                    </>
                }}
            </FormWrapper>
        </Modal>
    )
}
